<template>
  <div>
    <!-- 招標案件編輯 廠商選擇-->
    <div class="white-overlay"></div>
    <!-- Modal -->
    <div
      class="modal fade"
      :id="'addVendorModal' + vendorType"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">廠商選擇</div>
          <div class="modal-body">
            <div class="filter-block">
              <div class="filter-field">
                <input
                  type="type"
                  name="name"
                  v-model="filterKeyword"
                  placeholder="關鍵字"
                />
              </div>
              <div class="filter-btn-wrap" @click="doFilterCompany">
                <a class="btn btn-02">{{ $t("Buttons.Query") }}</a>
              </div>
            </div>
            <div class="item-select">
              <div id="left-item">
                <div class="filter-btn-wrap">
                  <label class="option">
                    <span>公司</span>
                  </label>
                </div>
                <div class="item-list">
                  <div
                    class="item_list"
                    v-for="company in filterMemberList"
                    :key="'left_' + company.vendorId"
                  >
                    <div class="item employee" v-if="usedCheckBox">
                      <input
                        :id="'left_' + company.vendorId + vendorType"
                        type="checkbox"
                        :value="company"
                        v-model="selectLeft"
                      />
                      <label :for="'left_' + company.vendorId + vendorType">{{
                        company.vendorAbbreviation
                      }}</label>
                    </div>
                    <div class="item employee" v-else>
                      <input
                        :id="'left_' + company.vendorId + vendorType"
                        type="radio"
                        :name="'leftSelectCompany' + vendorType"
                        :value="company"
                        v-model="selectOneLeft"
                      />
                      <label :for="'left_' + company.vendorId + vendorType"
                        >{{ company.vendorAbbreviation }} [{{
                          company.vendorId
                        }}]</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="center-item">
                <span class="add-item" @click="addClick"> &gt; </span>
                <span class="remove-item" @click="removeClick"> &lt; </span>
              </div>
              <div id="right-item">
                <span class="item-type">已選擇</span>
                <div class="item-list">
                  <div
                    class="item_list"
                    v-for="item in selecteds"
                    :key="'right_' + item.vendorId"
                  >
                    <div class="item" v-if="usedCheckBox">
                      <input
                        :id="'right_' + item.vendorId + vendorType"
                        type="checkbox"
                        :value="item"
                        v-model="selectRight"
                      />
                      <label :for="'right_' + item.vendorId + vendorType">{{
                        item.vendorAbbreviation
                      }}</label>
                    </div>
                    <div class="item" v-else>
                      <input
                        :id="'right_' + item.vendorId + vendorType"
                        type="radio"
                        :name="'rightSelectCompany' + vendorType"
                        :value="item"
                        v-model="selectOneRight"
                      />
                      <label :for="'right_' + item.vendorId + vendorType">{{
                        item.vendorAbbreviation
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-gray"
              data-dismiss="modal"
              @click="cancel"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-blue"
              data-dismiss="modal"
              @click.prevent="submitVendor"
            >
              {{ $t("Buttons.SavedData") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import $ from 'jquery'
import { Notification } from "element-ui";
export default {
  data() {
    return {
      selectLeft: [], //[左]側已挑選清單
      selectOneLeft: null, //[左]側已挑選清單(僅一筆)
      selectRight: [], //[右]側已挑選清單
      selecteds: [], //挑選後新增到右側的清單
      selectOneRight: null, //[右]側已挑選清單(僅一筆)
      memberList: [], //左側清單
      filterKeyword: "", //過濾條件
      filterValue: "",
    };
  },
  props: {
    vendorList: Array,
    factoryId: String,
    vendorType: String,
    rowQfmId: String,
  },
  methods: {
    doFilterCompany() {
      // 過濾查詢，左側清單過濾後的陣列
      this.filterValue = this.filterKeyword;
    },
    addClick() {
      if (this.vendorType === "-QM") {
        if (this.selectOneLeft) {
          this.selecteds.splice(0);
          this.selectRight.splice(0);
          this.selecteds.push(this.selectOneLeft);
          this.selectRight.push(this.selectOneLeft);
          this.selectOneLeft = null;
        }
      } else {
        //把左側挑選清單(selectLeft)，與目前右側已存在清單(selecteds)合併
        this.selecteds = [...this.selectLeft, ...this.selecteds];
        this.selectLeft = [];
      }
    },
    removeClick() {
      if (this.vendorType === "-QM") {
        if (this.selectOneRight) {
          this.selecteds.splice(0);
          this.selectRight.splice(0);
        }
      } else {
        this.selectRight.forEach((item, index) => {
          if (index == 0) {
            this.selecteds.splice(item, 1);
          } else {
            this.selecteds.splice(item - index, 1);
          }
        });
        this.selectRight = [];
      }
    },
    cancel() {
      this.selecteds = [];
      this.selectLeft = [];
      this.selectRight = [];
      this.filterValue = "";
      this.filterKeyword = "";
    },
    submitVendor() {
      if (!this.selecteds || this.selecteds.length === 0) {
        this.$alert("請先挑選公司至已選擇區域", "提示");
        return false;
      }

      const url = `${this.$baseApiUrl}/QFM/ChangeVendorQFM`;
      const requestObj = {
        id: this.rowQfmId,
        vendorId: this.selecteds[0].vendorId,
      };
      // console.log(requestObj);

      this.updateLoading(true);
      this.axios.patch(url, requestObj).then((response) => {
        this.updateLoading(false);
        // console.log(response);
        if (response.status === 200) {
          Notification({
            title: "成功",
            message: "修改成功",
            type: "success",
            duration: 5000,
          });
          this.$emit("updateVendors");
        } else {
          Notification({
            title: "失敗",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }

        this.cancel(); //清除
      });
    },
  },
  computed: {
    usedCheckBox() {
      if (this.vendorType === "-QM") {
        return false;
      }
      return true;
    },
    vendorIdList() {
      const { vendorList } = this;
      const vidList = [];
      if (vendorList && vendorList.length) {
        for (let k = 0; k < vendorList.length; k++) {
          let r = vendorList[k];
          if (!vidList.includes(r.vendorId)) {
            vidList.push(r.vendorId);
          }
        }
      }
      return vidList;
    },
    filterMemberList() {
      const v1 = this.factoryId;
      const v2 = this.filterValue;
      const { vendorIdList, selecteds } = this;
      const selectedIds = selecteds.map(function (item) {
        return item.vendorId;
      });
      return this.memberList.filter((n) => {
        if (vendorIdList && vendorIdList.includes(n.vendorId)) {
          return false;
        }
        if (selectedIds && selectedIds.includes(n.vendorId)) {
          return false;
        }
        if (v1) {
          if (!n.vendorId.startsWith(v1)) {
            return false;
          }
        }
        if (v2) {
          if (n.vendorAbbreviation && n.vendorAbbreviation.indexOf(v2) > -1) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
    },
  },
  mounted() {
    if (!this.isMember) {
      if ("-M" === this.vendorType) {
        this.$store.dispatch("getMemberList", {}).then((data) => {
          this.memberList = data;
        });
      } else if ("-QM" === this.vendorType) {
        this.$store.dispatch("getMemberQMList", {}).then((data) => {
          this.memberList = data;
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/select.scss";

.btn-blue {
  color: #fff !important;
  font-size: 0.85em;
  background: #343b55;
  border-radius: 6px;
}

.btn-yellow {
  background: #cca836;
  color: #fff;
}

.right {
  display: block;
  text-align: right;
}

.filter-btn-wrap {
  margin-top: 24px;
}

.option {
  margin-left: 0.2rem;
  cursor: pointer;
}
.item_list {
  margin-bottom: 5px;
}
.item-select #left-item .item-list .item,
.item-select #right-item .item-list .item {
  display: flex;
  align-items: center;
}
.item-select #left-item .item-list .item input[type="checkbox"],
.item-select #right-item .item-list .item input[type="checkbox"] {
  display: block;
  margin-right: 0.5rem;
}

.filter-block .filter-btn-wrap .btn {
  line-height: auto;
}

.filter-block .filter-field .flex > .age-input,
.filter-block .filter-field .flex > .year-input {
  width: 50px;
}

.white-overlay {
  background-color: rgba(0, 255, 255, 0.3);
}

.btn-gray {
  background-color: gray;
  color: white;
}

.item-select #right-item {
  padding-top: 55px;
}

.item-select #right-item .item-type {
  top: 33px;
}
</style>

